export const ENTRY_POINTS = ["glepnir", "caladan", "web"] as const;

export type EntryPoint = (typeof ENTRY_POINTS)[number];

export const DEFAULT_ENTRY_POINT: EntryPoint = "web";
